import { AnalyticsEvent } from "../models";


export class SummerExtrasStartOrderClickEvent implements AnalyticsEvent {
  name = "SummerExtrasStartOrderClickEvent";
  constructor(public readonly linkTitle: string) {}
}